var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeloitteLogoBlackedbacd33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 136 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m0 0.16965h136v26.11h-136v-26.11z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20 -22)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -30)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 40)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.358 13.325c0 4.0214-1.1034 7.1177-3.3071 9.2922s-5.2997 3.2633-9.2913 3.2633h-7.7593v-24.086h8.2998c3.8508 0 6.8221 0.98928 8.9171 2.9646 2.0917 1.9754 3.1408 4.8308 3.1408 8.5663m-6.7262 0.23126c0-2.2066-0.43498-3.8447-1.3049-4.9111-0.86996-1.0632-2.1877-1.5963-3.9628-1.5963h-1.8838v13.493h1.4425c1.9702 0 3.4127-0.57494 4.3306-1.7216 0.91793-1.1499 1.3785-2.9036 1.3785-5.2644",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m48.775 25.878h-6.4159v-25.635h6.4159v25.635z",
    fill: "#000",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.625 16.505c0 3.0546-0.81559 5.4346-2.4532 7.1402-1.6344 1.7088-3.9212 2.5631-6.8637 2.5631-2.821 0-5.0662-0.87365-6.7358-2.6177-1.6664-1.7473-2.5011-4.1081-2.5011-7.0856 0-3.0417 0.81878-5.4057 2.4532-7.092 1.6344-1.6863 3.9276-2.531 6.8829-2.531 1.8263 0 3.4383 0.39186 4.8391 1.1724 1.3977 0.77729 2.4787 1.8951 3.24 3.3533 0.75801 1.4518 1.1386 3.1541 1.1386 5.0974m-12.042 0c0 1.6028 0.21429 2.8265 0.63967 3.6648 0.42858 0.84153 1.145 1.2591 2.1493 1.2591 0.99469 0 1.6983-0.41755 2.1077-1.2591 0.41259-0.83832 0.61729-2.0621 0.61729-3.6648 0-1.5931-0.20789-2.7944-0.62368-3.607-0.41579-0.81262-1.1258-1.2205-2.1333-1.2205-0.9851 0-1.6887 0.40471-2.1173 1.2109-0.42538 0.8062-0.63967 2.0139-0.63967 3.6167",
    fill: "#000",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.389 25.878h-6.4127v-18.665h6.4127v18.665z",
    fill: "#000",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.389 5.4822h-6.4127v-5.3126h6.4127v5.3126z",
    fill: "#000",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.626 21.118c0.86356 0 1.8966-0.2152 3.0992-0.64239v4.6959c-0.86356 0.37259-1.6855 0.63918-2.4659 0.79978-0.7836 0.15739-1.6983 0.23768-2.7506 0.23768-2.1525 0-3.7069-0.52997-4.6568-1.5899-0.95312-1.0599-1.4265-2.6884-1.4265-4.8854v-7.6926h-2.2485v-4.8276h2.2485v-4.4646l6.4639-1.4036v5.8682h4.0939v4.8276h-4.0939v7.2654c0 1.2077 0.57891 1.8115 1.7367 1.8115",
    fill: "#000",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.91 21.118c0.86356 0 1.8966-0.2152 3.0992-0.64239v4.6959c-0.86356 0.37259-1.6855 0.63918-2.4659 0.79978-0.7836 0.15739-1.6983 0.23768-2.7506 0.23768-2.1525 0-3.7069-0.52997-4.6568-1.5899-0.95312-1.0599-1.4297-2.6884-1.4297-4.8854v-7.6926h-2.2453v-4.8276h2.2453v-4.4646l6.4639-1.4036v5.8682h4.0939v4.8276h-4.0939v7.2654c0 1.2077 0.57891 1.8115 1.7399 1.8115",
    fill: "#000",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.38 19.001c1.999 0 3.6206 1.6317 3.6206 3.6391 0 2.0075-1.6216 3.6391-3.6206 3.6391-2.0022 0-3.6238-1.6317-3.6238-3.6391 0-2.0075 1.6216-3.6391 3.6238-3.6391z",
    fill: "#86BC25",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.6 9.0835c-1.5256-1.4647-3.6877-2.2002-6.4895-2.2002-2.9393 0-5.2038 0.84474-6.7901 2.531-1.5864 1.6831-2.3796 4.1049-2.3796 7.2558 0 3.0514 0.85716 5.4057 2.5683 7.0599 1.7111 1.6509 4.1163 2.4796 7.2091 2.4796 1.4872 0 2.7666-0.099571 3.8412-0.29871 1.0619-0.19593 2.0949-0.54924 3.096-1.0599l-0.9851-4.2077c-0.72603 0.29229-1.4201 0.51712-2.0725 0.66487-0.94672 0.2152-1.9798 0.3212-3.1088 0.3212-1.2346 0-2.2101-0.2955-2.9265-0.88971-0.71644-0.59421-1.097-1.41-1.1418-2.4539h11.466v-2.8683c0-2.7559-0.76121-4.8693-2.2868-6.334zm-9.0482 5.1488c0.089554-1.0214 0.387-1.7698 0.89554-2.2484 0.50854-0.47858 1.1386-0.71627 1.8934-0.71627 0.82198 0 1.4745 0.26659 1.9606 0.8062 0.48615 0.53961 0.74202 1.2559 0.76441 2.1584h-5.514z",
    fill: "#000",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.789 9.0835c-1.5256-1.4647-3.6877-2.2002-6.4895-2.2002-2.9393 0-5.2038 0.84474-6.7901 2.531-1.5864 1.6831-2.3796 4.1049-2.3796 7.2558 0 3.0514 0.85716 5.4057 2.5683 7.0599 1.7111 1.6509 4.1163 2.4796 7.2091 2.4796 1.4872 0 2.7666-0.099571 3.8412-0.29871 1.0619-0.19593 2.0949-0.54924 3.096-1.0599l-0.9851-4.2077c-0.72603 0.29229-1.4201 0.51712-2.0725 0.66487-0.94672 0.2152-1.9798 0.3212-3.1088 0.3212-1.2346 0-2.2101-0.2955-2.9265-0.88971-0.71644-0.59421-1.097-1.41-1.1418-2.4539h11.466v-2.8683c0-2.7559-0.76121-4.8693-2.2868-6.334zm-9.0482 5.1488c0.089554-1.0214 0.387-1.7698 0.89554-2.2484 0.50854-0.47858 1.1386-0.71627 1.8934-0.71627 0.82198 0 1.4745 0.26659 1.9606 0.8062 0.48615 0.53961 0.74202 1.2559 0.76441 2.1584h-5.514z",
    fill: "#000",
    mask: "url(#a)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeloitteLogoBlackedbacd33);
export default __webpack_public_path__ + "static/media/deloitte_logo_black.edbacd33.808d5f5538ac75e397d839ee3251a78d.svg";
export { ForwardRef as ReactComponent };